// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"e2e56a9a","272":"5a4a61fe","279":"4537ae27","453":"f1f72032","539":"d1010c73","579":"ba7a8b5b","693":"9e576e68"}[chunkId] + ".chunk.js";
};